const DEFAULT_ERROR_MESSAGE = 'Doslo je do greske. Pokusajte ponovo.';

// Poruka za korisnika: poruka sa beka (na srpskom) ili zadati fallback.
// Namerno se NE koristi error.message - to je tehnicka poruka axios-a na
// engleskom ("Network Error", "Request failed with status code 500"...).
const extractErrorMessage = (error, fallBackMessage) => {
  const backendMessage = error?.response?.data?.message;
  if (typeof backendMessage === 'string' && backendMessage.trim()) {
    return backendMessage;
  }
  return fallBackMessage || DEFAULT_ERROR_MESSAGE;
};

export default extractErrorMessage;
